'use client'
import React from 'react';
import { motion } from 'framer-motion';
import { FaPlay } from 'react-icons/fa';

interface LessonProps {
  name: string;
  description: string;
  videoId: string;
  onWatchClick: () => void;
}

const Lesson: React.FC<LessonProps> = ({ name, description, videoId, onWatchClick }) => {
  return (
    <motion.div 
      className="border border-white p-4 sm:p-6 flex flex-col justify-between"
      variants={{
        hidden: { opacity: 0, y: 20 },
        show: { opacity: 1, y: 0 }
      }}
    >
      <div>
        <motion.h3 
          className="text-xl sm:text-2xl uppercase tracking-wider mb-2 sm:mb-4"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          {name}
        </motion.h3>
        <motion.p 
          className="text-sm sm:text-base text-gray-400 mb-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3, delay: 0.1 }}
        >
          {description}
        </motion.p>
      </div>
      <motion.button 
        onClick={onWatchClick}
        className="mt-2 sm:mt-4 flex items-center justify-center w-full py-2 bg-white text-black hover:bg-gray-200 transition duration-300"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        disabled={!videoId}
      >
        <FaPlay className="mr-2" /> Watch Clip
      </motion.button>
    </motion.div>
  );
};

export default Lesson;